import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolderWithFile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M44.5711 5.33301H25.465C21.1804 5.33301 17.71 8.78386 17.71 13.0442V55.4445C17.71 59.7049 21.1804 63.1558 25.465 63.1558H54.5359C58.8204 63.1558 62.2909 59.7049 62.2909 55.4445V22.9528C62.2909 20.9081 61.4721 18.9468 60.0207 17.4989L50.0559 7.59041C48.5998 6.14253 46.6273 5.33301 44.5711 5.33301Z",
			fill: "url(#paint0_linear_198_12680)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -.844209,
			y: 21.2105,
			width: 81.6904,
			height: 61.3867,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(4.42px)",
					clipPath: "url(#bgblur_0_198_12680_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 8.84421,
			d: "M43.3054 38.4224V39.0891H43.9721H65.9385C68.923 39.0891 71.3357 41.4946 71.3357 44.4565V67.7187C71.3357 70.6806 68.923 73.0862 65.9385 73.0862H14.0639C11.0794 73.0862 8.66667 70.6806 8.66667 67.7187V34.7034C8.66667 32.5086 10.458 30.7214 12.6717 30.7214H39.3004C41.5141 30.7214 43.3054 32.5086 43.3054 34.7034V38.4224Z",
			fill: "#94DCC8",
			fillOpacity: .6,
			stroke: "url(#paint1_linear_198_12680)",
			strokeWidth: 1.33333
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_198_12680_clip_path",
				transform: "translate(0.844209 -21.2105)",
				children: /* @__PURE__ */ _jsx("path", { d: "M43.3054 38.4224V39.0891H43.9721H65.9385C68.923 39.0891 71.3357 41.4946 71.3357 44.4565V67.7187C71.3357 70.6806 68.923 73.0862 65.9385 73.0862H14.0639C11.0794 73.0862 8.66667 70.6806 8.66667 67.7187V34.7034C8.66667 32.5086 10.458 30.7214 12.6717 30.7214H39.3004C41.5141 30.7214 43.3054 32.5086 43.3054 34.7034V38.4224Z" })
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_198_12680",
				x1: 62.2909,
				y1: 34.2444,
				x2: 17.71,
				y2: 34.2444,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00897B" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#50AE9C"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_198_12680",
				x1: 4.79988,
				y1: 33.176,
				x2: 30.4816,
				y2: 90.6237,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: .765625,
					stopColor: "white",
					stopOpacity: 0
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgFolderWithFile);
export { ForwardRef as ReactComponent };
